import React, { createContext, useContext, useState, useEffect } from "react";
import { X } from "lucide-react";

const VideoContext = createContext({ open: (_id) => {} });

export const useVideo = () => useContext(VideoContext);

// id → YouTube video ID (single source of truth used by Tracks + Media)
export const TRACK_VIDEOS = {
  Cupid: "IvRuLsPnZ7Q",
  "Flowsy Fly": "6xm8SgDpVak",
  "Anatomic Impulse": "lIT_I9Ad6wk",
  "Raft of Time": "iJHuJDUayVU",
  "Love Sick Edifice": "YS79zofW4qQ",
  "Falling With Style": "QIVseYAiqRM",
};

// title → Bandcamp URL (for "Listen on Bandcamp" links on track cards)
export const TRACK_BANDCAMP = {
  Cupid: "https://conceptandformality.bandcamp.com/track/cupid",
};

export const BANDCAMP_ARTIST_URL = "https://conceptandformality.bandcamp.com";

export function VideoProvider({ children }) {
  const [videoId, setVideoId] = useState(null);

  useEffect(() => {
    if (!videoId) return;
    const onKey = (e) => e.key === "Escape" && setVideoId(null);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [videoId]);

  return (
    <VideoContext.Provider value={{ open: setVideoId, close: () => setVideoId(null), current: videoId }}>
      {children}
      {videoId && (
        <div
          data-testid="video-modal"
          className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-md flex items-center justify-center p-4"
          onClick={() => setVideoId(null)}
        >
          <button
            data-testid="video-modal-close"
            onClick={() => setVideoId(null)}
            aria-label="Close video"
            className="absolute top-5 right-5 z-10 w-11 h-11 flex items-center justify-center border border-white/30 bg-black/60 text-white hover:border-[#FF00E5] hover:text-[#FF00E5] hover:glow-magenta transition-all"
          >
            <X size={18} />
          </button>
          <div
            className="relative w-full max-w-5xl aspect-video border border-[#FF00E5]/40 glow-magenta"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
              title="Concept And Formality video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full bg-black"
            />
          </div>
        </div>
      )}
    </VideoContext.Provider>
  );
}
